// Where a user lands after signing in. Someone with exactly one dial has nothing to pick from, so My Dials
// is a one-card page they always have to click through — send them straight to the dial instead.
//
// Once per browser-tab session: after the automatic hop, My Dials stays reachable (header link, the dial's
// back crumb) without being bounced away again. Cleared on logout so the next person to sign in gets their
// own landing decision.
const AUTO_OPEN_KEY = "kdu.landedOnSoleDial";

/** Claims the one automatic hop this session gets; false if it has already been used. */
export function claimSoleDialLanding(): boolean {
  try {
    if (sessionStorage.getItem(AUTO_OPEN_KEY)) {
      return false;
    }
    sessionStorage.setItem(AUTO_OPEN_KEY, "1");
    return true;
  } catch {
    return false; // private-mode / storage-disabled: just show My Dials
  }
}

export function resetSoleDialLanding(): void {
  try {
    sessionStorage.removeItem(AUTO_OPEN_KEY);
  } catch {
    // nothing to reset
  }
}
